import { featuredCategories } from '@/mocks/categories';

const imageUrls: Record<string, string> = {
  'feat-shoes': 'https://readdy.ai/api/search-image?query=Premium%20chunky%20sole%20sneakers%20in%20cream%20and%20sand%20tones%20displayed%20on%20textured%20oatmeal%20fabric%20with%20strong%20side%20lighting%20casting%20dramatic%20shadows%2C%20product%20photography%2C%20luxury%20streetwear%20aesthetic%2C%20detailed%20sole%20texture%20visible%2C%20warm%20neutral%20atmosphere%2C%20high%20end%20editorial%20style&width=800&height=1000&seq=feat-shoes-v2-101&orientation=portrait',
  'feat-hoodies': 'https://readdy.ai/api/search-image?query=Oversized%20moss%20green%20heavyweight%20cotton%20hoodie%20laid%20flat%20on%20warm%20cork%20surface%20with%20natural%20window%20light%20from%20left%2C%20visible%20ribbed%20cuffs%20and%20drawstring%20details%2C%20cozy%20streetwear%20aesthetic%2C%20soft%20fabric%20texture%2C%20clean%20composition%2C%20warm%20earthy%20tones&width=600&height=400&seq=feat-hoodies-v2-102&orientation=landscape',
  'feat-tshirts': 'https://readdy.ai/api/search-image?query=Premium%20heavyweight%20white%20crewneck%20tshirt%20folded%20neatly%20on%20warm%20amber%20toned%20wooden%20surface%20with%20gentle%20morning%20light%20and%20subtle%20grain%20texture%20visible%2C%20minimalist%20product%20photography%2C%20clean%20shadow%20lines%2C%20soft%20warm%20neutral%20palette%2C%20refined%20basics%20aesthetic&width=600&height=400&seq=feat-tshirts-v2-103&orientation=landscape',
  'feat-jackets': 'https://readdy.ai/api/search-image?query=Distressed%20vintage%20wash%20denim%20jacket%20with%20visible%20stitching%20and%20copper%20buttons%20styled%20flat%20on%20rustic%20linen%20textile%20with%20natural%20diffused%20light%2C%20editorial%20streetwear%20photography%2C%20detailed%20fabric%20texture%2C%20warm%20grey%20undertones%2C%20fashion%20editorial%20composition&width=700&height=500&seq=feat-jackets-v2-104&orientation=landscape',
  'feat-bags': 'https://readdy.ai/api/search-image?query=Structured%20tan%20leather%20crossbody%20bag%20with%20gold%20hardware%20placed%20on%20woven%20rattan%20surface%20with%20soft%20sunshine%20and%20palm%20leaf%20shadow%20patterns%2C%20resort%20fashion%20aesthetic%2C%20rich%20cognac%20brown%20tones%2C%20elegant%20travel%20accessory%20photography%2C%20sophisticated%20warm%20composition&width=700&height=500&seq=feat-bags-v2-105&orientation=landscape',
  'feat-accessories': 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20minimalist%20jewelry%20including%20layered%20gold%20chain%20necklaces%20and%20tortoiseshell%20sunglasses%20arranged%20on%20raw%20silk%20fabric%20with%20soft%20directional%20light%2C%20luxury%20accessories%20flatlay%2C%20warm%20champagne%20tones%2C%20refined%20editorial%20aesthetic%2C%20delicate%20shadows&width=700&height=500&seq=feat-accessories-v2-106&orientation=landscape',
};

const categoryLabels: Record<string, string> = {
  'Shoes': 'Shoes',
  'Hoodies/Sweaters': 'Hoodies',
  'T-Shirts': 'T-Shirts',
  'Jackets': 'Jackets',
  'Bags': 'Bags',
  'Accessories': 'Accessories',
};

const categoryIcons: Record<string, string> = {
  'Shoes': 'ri-footprint-line',
  'Hoodies/Sweaters': 'ri-t-shirt-line',
  'T-Shirts': 'ri-shirt-line',
  'Jackets': 'ri-honour-line',
  'Bags': 'ri-briefcase-line',
  'Accessories': 'ri-glasses-line',
};

export default function FeatureGrid() {
  return (
    <section className="px-6 md:px-10 py-12 md:py-20 bg-background-100/60">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
          Explore <span className="text-accent-500">Streetwear</span><br />
          &amp; <span className="text-accent-500">Sneakers</span>
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
          Categorias mais populares do CSSBuy Spreadsheet com produtos atualizados para 2026
        </p>
      </div>

      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-4">
        <a
          href={featuredCategories[0].url}
          target="_blank"
          rel="noopener nofollow"
          className="lg:w-1/2 relative rounded-3xl overflow-hidden group cursor-pointer h-[400px] md:h-[520px]"
        >
          <img
            src={imageUrls['feat-shoes']}
            alt="Shoes - CSSBuy Spreadsheet"
            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent"></div>
          <div className="absolute bottom-6 left-6 flex items-center gap-3 bg-white/90 backdrop-blur-sm px-5 py-2.5 rounded-full">
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-footprint-line text-accent-600 text-xs"></i>
            </span>
            <span className="text-foreground-900 text-sm font-bold whitespace-nowrap">Shoes</span>
          </div>
        </a>

        <div className="lg:w-1/2 flex flex-col gap-4">
          <a
            href={featuredCategories[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="flex-1 relative rounded-3xl overflow-hidden group cursor-pointer min-h-[190px]"
          >
            <img
              src={imageUrls['feat-hoodies']}
              alt="Hoodies/Sweaters - CSSBuy Spreadsheet"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-5 left-5 flex items-center gap-2.5 bg-secondary-100/90 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-200">
                <i className="ri-t-shirt-line text-secondary-700 text-xs"></i>
              </span>
              <span className="text-secondary-900 text-sm font-bold whitespace-nowrap">Hoodies/Sweaters</span>
            </div>
          </a>
          <a
            href={featuredCategories[2].url}
            target="_blank"
            rel="noopener nofollow"
            className="flex-1 relative rounded-3xl overflow-hidden group cursor-pointer min-h-[190px]"
          >
            <img
              src={imageUrls['feat-tshirts']}
              alt="T-Shirts - CSSBuy Spreadsheet"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-5 left-5 flex items-center gap-2.5 bg-primary-100/90 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-200">
                <i className="ri-shirt-line text-primary-700 text-xs"></i>
              </span>
              <span className="text-primary-700 text-sm font-bold whitespace-nowrap">T-Shirts</span>
            </div>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-4 grid grid-cols-2 md:grid-cols-3 gap-4">
        {featuredCategories.slice(3).map((cat) => (
          <a
            key={cat.name}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="relative rounded-3xl overflow-hidden group cursor-pointer h-48 md:h-64"
          >
            <img
              src={imageUrls[cat.imageSeq]}
              alt={`${cat.name} - CSSBuy Spreadsheet`}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-4 left-4 flex items-center gap-2 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${categoryIcons[cat.name] || 'ri-price-tag-3-line'} text-accent-600 text-[10px]`}></i>
              </span>
              <span className="text-foreground-900 text-xs md:text-sm font-bold whitespace-nowrap">{categoryLabels[cat.name] || cat.name}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}